import { render } from "./SchemaDrivenForm.vue?vue&type=template&id=36d790d8&scoped=true"
import script from "./SchemaDrivenForm.vue?vue&type=script&lang=js"
export * from "./SchemaDrivenForm.vue?vue&type=script&lang=js"

import "./SchemaDrivenForm.vue?vue&type=style&index=0&id=36d790d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d790d8"]])

export default __exports__